/**
 * @file: ListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import ListModel from '../../common/ReportListModel';
import {assign, omit} from 'lodash';

export default class Model extends ListModel {

    filter = assign(this.filter, {
        associatedId: null,
        associatedType: null,
        timeRange: null
    });

    init() {
        super.init();
        this.listRequester = this.api.statsLinkList;
    }

    adaptData(data) {
        data.result.forEach(item => {
            item.clickRatioPercent = this.toPercentText(item.clickRatio);
        });
        return data;
    }

    /**
     * @override
     */
    requestAderList() {}

    prepareParams(params) {
        // 去除路由 query中的 parent参数
        return omit(params, ['parentId', 'parentType', 'aderId', 'grandParentType', 'grandParentId']);
    }
}
